"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var NotificationInputField = function NotificationInputField(_ref) {
  var type = _ref.type,
      value = _ref.value,
      error = _ref.error,
      disabled = _ref.disabled,
      onInputChange = _ref.onInputChange,
      onBlur = _ref.onBlur,
      placeholder = _ref.placeholder;
  return (0, _preact.h)("div", null, (0, _preact.h)("input", {
    type: type,
    className: "notification-input",
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    onBlur: onBlur // @ts-expect-error
    ,
    onInput: function onInput(e) {
      var _e$target;

      return onInputChange((_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value);
    }
  }), error && (0, _preact.h)("div", {
    className: "validation-error"
  }, error));
};

var _default = NotificationInputField;
exports.default = _default;